import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/vouchers";

export default {
  get(payload) {
    return Client.get(resource, {
      params: {
        page: payload.page || 1,
        page_size: payload.page_size || 10,
        search: payload.search || "",
      },
    });
  },
  create(payload) {
    return Client.post(resource, payload);
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  detail(id) {
    return Client.get(`${resource}/${id}`);
  },
};
